import { useRef, useEffect, useState } from 'react';

const useIdleTimer = (speech, idleEncouragementTimeout, idleExpiredTimeout) => {
  const currentIdleTimeout = useRef(undefined);
  const [idleSpeechPlaying, setIdleSpeechPlaying] = useState(undefined); // Instantiate this value as undefined so useEffects can tell difference between undefined and false
  const [idleTimeoutExpired, setIdleTimeoutExpired] = useState(false);

  const clearIdleTimer = () => {
    if (currentIdleTimeout.current) clearTimeout(currentIdleTimeout.current);
  };

  const resetIdleTimer = (idleEncouragementText) => {
    clearIdleTimer();
    startIdleTimer(idleEncouragementText);
  };

  const startIdleTimer = (idleEncouragementText) => {
    setIdleTimeoutExpired(false);
    currentIdleTimeout.current = setTimeout(async () => {
      if (idleEncouragementText) {
        setIdleSpeechPlaying(true);
        await speech.speakWithPromise({
          textToSpeak: idleEncouragementText,
        });
        setIdleSpeechPlaying(false);
      }
      currentIdleTimeout.current = setTimeout(() => {
        setIdleTimeoutExpired(true);
      }, idleExpiredTimeout);
    }, idleEncouragementTimeout);
  };

  useEffect(() => {
    return () => {
      clearIdleTimer();
    };
  }, []);

  return {
    resetIdleTimer,
    clearIdleTimer,
    idleSpeechPlaying,
    idleTimeoutExpired
  };
};

export default useIdleTimer;
